module.exports = __webpack_public_path__ + "assets/img/head1-zh.979f869e.png";